import React, { createContext, useContext, useState, ReactNode } from 'react';

export type ProfilePage = 'Home' | 'Profile' | 'Your plans' | 'Billing' | 'FAQs' | 'Resources' | 'ID Cards';

interface ProfileNavigationContextType {
  activePage: ProfilePage;
  setActivePage: (page: ProfilePage) => void;
}

const ProfileNavigationContext = createContext<ProfileNavigationContextType | undefined>(undefined);

interface ProfileNavigationProviderProps {
  children: ReactNode;
}

export const ProfileNavigationProvider: React.FC<ProfileNavigationProviderProps> = ({ children }) => {
  const [activePage, setActivePage] = useState<ProfilePage>('Home');

  return (
    <ProfileNavigationContext.Provider value={{ activePage, setActivePage }}>
      {children}
    </ProfileNavigationContext.Provider>
  );
};

export const useProfileNavigation = () => {
  const context = useContext(ProfileNavigationContext);
  if (context === undefined) {
    throw new Error('useProfileNavigation must be used within a ProfileNavigationProvider');
  }
  return context;
};